import { createContext } from "react";

export const ProductSelectedContext = createContext(null);